function waitForShopifyFormEmbed(callback, interval = 300, maxAttempts = 20) {
  let attempts = 0;
  const timer = setInterval(() => {
    const el = document.querySelector("shopify-forms-embed");
    if (el && el.shadowRoot) {
      clearInterval(timer);
      callback(el);
    } else if (++attempts > maxAttempts) {
      clearInterval(timer);
      console.warn("Shopify form embed not found in time");
    }
  }, interval);
}

waitForShopifyFormEmbed((el) => {
  const shadow = el.shadowRoot;
  const style = document.createElement("style");
  style.textContent = `
    ._textHeading_2aowh_35 {
      font-size: 40px !important;
      line-height: initial !important;
    }

    ._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 {
      flex-direction: column-reverse !important;
    }

    ._formFieldset_cit2d_82 input {
      font-size: 18px !important;
      padding: 12px !important;
    }

    ._selectToggle_12thd_25 {
      padding: 12px !important;
      min-height: 45px !important;
    }

    ._selectToggleText_12thd_25,._formSubmitButton_cit2d_96 {
      font-size: 18px !important;
    }

    ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74,
    ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
      transform: none !important;
    }

    ._formFieldset_cit2d_82 label {
      position: initial !important;
      margin-bottom: 4px !important;
      color: #5e6c74 !important;
      line-height: 20px !important;
      width: fit-content !important;
    }

    div._birthdayText_rzr7e_15 {
      padding-bottom: 0 !important;
    }

    .phone-country-selector {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }

    ._selectContainer_12thd_6 {
      width: 100%
    }

    div._formDisclaimer_cit2d_38 {
      font-size: 14px !important;
      line-height: initial !important;
    }

    ._formBannerHeading_z5ku3_9 {
      font-size: 40px !important;
      line-height: initial !important;
      margin-bottom: 30px !important;
    }

    #label-custom\\#model_number {
      pointer-events: auto !important;
    }
   
    @media (min-width: 768px) {
      ._textHeading_2aowh_35 {
        font-size: 48px !important;
        margin-bottom: 14px !important;
      }

      ._gridItemContent_1q1d2_257 {
        padding-top: 56px !important;
        padding-bottom: 56px !important;
      }
    }

    @media (min-width: 1024px) {
      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        max-width: 600px !important;
      }
    }
  `;
  shadow.appendChild(style);

  const label = shadow.querySelector('label[id="label-custom#model_number"]');
  if (label) {
    /* ========================================================
       🔥 建立 popup trigger（外部按鈕）
       ======================================================== */
    const externalBtn = document.createElement("button");
    externalBtn.id = "openPopupButton";
    externalBtn.className = "find-model-number";
    externalBtn.style.cssText = `
      position: absolute !important;
      pointer-events: auto !important;
      color: #007aff !important;
      font-size: 12px;
      cursor: pointer;
      text-decoration: underline;
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      z-index: 3;
    `;
    externalBtn.textContent = "How to find your model number?";
    label.insertAdjacentElement("afterend", externalBtn);
    // document.body.appendChild(externalBtn);
    const popup = document.getElementById(
      "PagePopup-template--19924862140579__pagePopup_CJGEdx"
    );

    function openPopup() {
      popup.classList.remove("is-close");
      popup.classList.add("is-open");
    }

    externalBtn.addEventListener("click", (e) => {
      console.log("btn click");
      e.preventDefault();
      openPopup();
    });

    function repositionButton() {
      if (!label || label.offsetParent === null) return;

      const labelRect = label.getBoundingClientRect();
      const containerRect = externalBtn.offsetParent.getBoundingClientRect();

      externalBtn.style.top = `${labelRect.top - containerRect.top}px`;
      externalBtn.style.left = `${labelRect.right - containerRect.left + 8}px`;
    }

    repositionButton();
    window.addEventListener("resize", repositionButton);
    window.addEventListener("scroll", repositionButton);

    // const categorySelectBtn = shadow.querySelector(
    //   'button[aria-controls="custom#select_product_category-selector-dropdown"]'
    // );

    // if (categorySelectBtn) {
    //   // 監聽 dropdown toggle 的點擊
    //   categorySelectBtn.addEventListener("click", () => {
    //     // 點擊後等 Shopify Forms 更新 aria-expanded
    //     requestAnimationFrame(() => {
    //       const isOpened =
    //         categorySelectBtn.getAttribute("aria-expanded") == "true";

    //       if (isOpened) {
    //         // 下拉打開 → 隱藏你的按鈕
    //         externalBtn.style.visibility = "visible";
    //         externalBtn.style.pointerEvents = "auto";
    //       } else {
    //         // 下拉關閉 → 顯示你的按鈕
    //         externalBtn.style.visibility = "hidden";
    //         externalBtn.style.pointerEvents = "none";
    //       }
    //     });
    //   });
    // }
  }
});
